import React, { useContext } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { withRouter, useHistory } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { FullscreenLayout } from "core/layouts/container";

import Grid from "@material-ui/core/Grid";

import { useTheme } from "@material-ui/core/styles";

import Box from "@material-ui/core/Box";

import { useStyles } from "./styles";

interface ContainerProps {
  children: any;
  mt: number;
  pl: number;
  pr: number;
}
const Container = (props: React.PropsWithChildren<ContainerProps | any>) => {
  const { children, mt, pl, pr } = props;
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();
  const win: any = window;
  const langDir = i18n.dir(win["lang"] as string);

  return (
    <>
      <Grid
        container
        className={classes.root}
        style={{
          direction: langDir,
        }}
        direction="column"
        justify="flex-start"
        alignItems="center"
      >
        <Grid item xs={12} style={{ width: "100%" }}>
          <Box
            mt={mt ? mt : theme.spacing(2)}
            pl={pl ? pl : theme.spacing(1.5)}
            pr={pr ? pr : theme.spacing(1.5)}
            className={classes.container}
          >
            {children}
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
export default withRouter(Container);
